import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, viewChild } from "@angular/core";
import { SafeResourceUrl } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { PatientService } from "@main/app-layout/components/patient-switch/patient.service";
import { UserService } from "@main/users";
import { FormButtonsConfig } from "@mipro/components";
import { EpisodeSelectMode } from "@project/episode/episode-select/episode-select-mode";
import { EpisodeSelectOption } from "@project/episode/episode-select/episode-select-option";
import { IEpisode } from "@project/models/episodes/episode";
import { EpisodeCreatedFrom } from "@project/models/episodes/episode_createdFrom";
import { ConfirmationService, MessageService, SelectItem } from "primeng/api";
import { FormIODefinition } from "@features/bb-formio";
import { FormIODefinitionService } from "@features/bb-formio/services/formio-definition.service";
import { Message } from "@bbwt/classes";
import { Dialog } from "primeng/dialog";

@Component({
    selector: "formio-select-form-dialog",
    templateUrl: "./formio-select-form-dialog.component.html"
})
export class FormIOFormSelectDialogComponent implements OnInit {
    buttonsConfig = <FormButtonsConfig>{
        saveLabel: "Select",
        saveFunc: () => {
            this.select();
        },
        cancelFunc: () => {
            this.cancel();
        }
    };

    @Output() readonly onCancel = new EventEmitter();
    @Output() readonly onSelect = new EventEmitter<FormIODefinition>();

    @Input() moduleId: string = null;
    @Input() visible = true;
    @Input() moduleName: string = null;

    @ViewChild("selectFormDialog") dialog : Dialog

    allDefinitions: FormIODefinition[] = [];

    definitionDropdownOptions: SelectItem[]
    selectedDefinitionId: string;

    constructor(
        private formIODefinitionService: FormIODefinitionService,
        private messageService : MessageService
     ) {
    }

    async ngOnInit() {

        // All default MiPro Modules will send moduleId = 0,
        // In that case we need to find FormDefinitions whose category matches the module name
        if(this.moduleId && !this.moduleId.startsWith("0")){
            this.allDefinitions = await this.formIODefinitionService.getForModule(this.moduleId);
        } else{
            this.allDefinitions = await this.formIODefinitionService.getForModuleByName(this.moduleName);
        }
        
        this.allDefinitions = this.allDefinitions.filter (x => !x.activeRevision.mufCapable || (x.activeRevision.mufCapable && x.activeRevision.isMUFReady))
       
        if (this.allDefinitions.length == 0){
            this.messageService.add(Message.Error("Module does not contain form definitions", "Error"));
            this.dialog.close(null);
        } else if (this.allDefinitions.length == 1){
            this.selectedDefinitionId = this.allDefinitions[0].id
            this.select();
            this.dialog.close(null);
        }

        this.definitionDropdownOptions = this.allDefinitions.map(x => <SelectItem> {
            value: x.id,
            label: x.name
        })


    }

    cancel() {
        this.onCancel.emit();
    }

    select() {
        const selectedDefinition = this.allDefinitions.find(x => x.id === this.selectedDefinitionId);
        this.onSelect.emit(selectedDefinition);
    }
}
